module.exports = __webpack_public_path__ + "assets/pms-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/pms-bg.jpg
// module id = 1666
// module chunks = 7